import { Send, Settings, PhoneCall, Wallet } from "lucide-react";

const actions = [
  { icon: Settings, text: "Cambiare le istruzioni" },
  { icon: PhoneCall, text: "Sapere chi ha chiamato" },
  { icon: Wallet, text: "Ricaricare i crediti" },
];

export default function TelegramControl() {
  return (
    <section className="py-24 md:py-32 bg-brand-ink text-brand-bg relative overflow-hidden" data-testid="telegram-section">
      <div className="absolute inset-0 grain-bg pointer-events-none opacity-40"></div>
      <div className="max-w-5xl mx-auto px-6 md:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-3">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-bg/10 border border-brand-bg/20 mb-6">
              <span className="text-base leading-none">✈️</span>
              <span className="text-xs text-brand-bg/80 tracking-wide uppercase">Il punto di forza</span>
            </div>

            <h2 className="font-heading text-4xl md:text-5xl text-brand-bg mb-6 leading-tight" data-testid="telegram-title">
              Gestisci tutto da Telegram.<br />
              <span className="text-brand-terra italic">Senza app, senza dashboard.</span>
            </h2>

            <p className="text-lg text-brand-bg/80 leading-relaxed mb-8 max-w-xl" data-testid="telegram-text">
              Il tuo assistente vocale lo controlli direttamente da Telegram — l'app
              che hai già sul telefono. Vuoi cambiare le istruzioni? Scrivi a Telegram.
              Vuoi sapere chi ha chiamato? Telegram. Vuoi ricaricare i crediti? Telegram.
              Zero dashboard, zero login, zero complicazioni.{" "}
              <span className="text-brand-bg font-medium">Un messaggio e fatto.</span>
            </p>

            <div className="flex flex-wrap gap-3">
              {actions.map((a, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 px-4 py-2 rounded-full bg-brand-bg/10 border border-brand-bg/20 text-sm text-brand-bg"
                  data-testid={`telegram-action-${i + 1}`}
                >
                  <a.icon className="w-4 h-4 text-brand-terra" strokeWidth={2} />
                  {a.text}
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-2 flex justify-center md:justify-end">
            <div className="w-40 h-40 md:w-52 md:h-52 rounded-full bg-brand-bg/10 border border-brand-bg/20 flex items-center justify-center">
              <Send className="w-20 h-20 md:w-24 md:h-24 text-brand-terra" strokeWidth={1.25} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
